import { inr } from "@/lib/api";

export default function Invoice({ order }) {
  return (
    <div className="print-area p-6" data-testid="invoice">
      <div className="text-center border-b border-dashed border-[#EBE8E2] pb-3 mb-3">
        <div className="font-heading font-extrabold text-xl text-[#2D2C2A]">Thali POS Restaurant</div>
        <div className="text-xs text-[#7A7873] mt-0.5">Mumbai, India · +91 98765 43210</div>
        <div className="text-xs text-[#7A7873]">GSTIN: 27AAAAA0000A1Z5</div>
      </div>

      <div className="text-xs space-y-0.5 mb-3">
        <div className="flex justify-between"><span>Invoice</span><span className="font-mono-num">{order.order_no}</span></div>
        <div className="flex justify-between"><span>Date</span><span className="font-mono-num">{new Date(order.created_at).toLocaleString("en-IN")}</span></div>
        <div className="flex justify-between"><span>Type</span><span className="capitalize">{order.type}</span></div>
        {order.waiter_name && <div className="flex justify-between"><span>Staff</span><span>{order.waiter_name}</span></div>}
        {order.customer_name && <div className="flex justify-between"><span>Customer</span><span>{order.customer_name}</span></div>}
      </div>

      <table className="w-full text-xs mb-3">
        <thead>
          <tr className="border-y border-[#EBE8E2]">
            <th className="text-left py-1.5">Item</th>
            <th className="text-right py-1.5 w-10">Qty</th>
            <th className="text-right py-1.5 w-16">Rate</th>
            <th className="text-right py-1.5 w-20">Amount</th>
          </tr>
        </thead>
        <tbody>
          {(order.items || []).map((it, i) => (
            <tr key={i} className="border-b border-dashed border-[#EBE8E2]">
              <td className="py-1.5">{it.name}</td>
              <td className="py-1.5 text-right font-mono-num">{it.qty}</td>
              <td className="py-1.5 text-right font-mono-num">{inr(it.price)}</td>
              <td className="py-1.5 text-right font-mono-num">{inr(it.price * it.qty)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="text-xs space-y-0.5 font-mono-num">
        <div className="flex justify-between"><span>Subtotal</span><span>{inr(order.subtotal)}</span></div>
        {order.discount_amount > 0 && (
          <div className="flex justify-between"><span>Discount</span><span>− {inr(order.discount_amount)}</span></div>
        )}
        <div className="flex justify-between"><span>CGST</span><span>{inr(order.cgst)}</span></div>
        <div className="flex justify-between"><span>SGST</span><span>{inr(order.sgst)}</span></div>
        <div className="flex justify-between font-bold text-sm pt-1 mt-1 border-t border-[#2D2C2A] text-[#2D2C2A]">
          <span>TOTAL</span><span>{inr(order.total)}</span>
        </div>
      </div>

      {order.payments?.length > 0 && (
        <div className="text-xs mt-3 pt-3 border-t border-dashed border-[#EBE8E2]">
          <div className="font-semibold mb-1">Payments</div>
          {order.payments.map((p, i) => (
            <div key={i} className="flex justify-between text-[#7A7873]">
              <span className="capitalize">{p.mode}{p.reference ? ` · ${p.reference}` : ""}</span>
              <span className="font-mono-num">{inr(p.amount)}</span>
            </div>
          ))}
        </div>
      )}

      <div className="text-center text-xs text-[#7A7873] mt-4 pt-3 border-t border-dashed border-[#EBE8E2]">
        Thank you for dining with us!
      </div>
    </div>
  );
}
